import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, computed, inject, input, signal, viewChild } from '@angular/core';
import { IconModule } from '@teamfoster/sdk/icon';

import { InViewportDirective } from '@teamfoster/sdk/in-view';

import { MediaPointMapComponent } from '../media-point-map/media-point-map.component';
import { ImageMapItem } from 'src/app/product-galleries/models/product-gallery.model';
import { Media } from '@teamfoster/sdk/image';

@Component({
  selector: 'app-media',
  imports: [IconModule, NgOptimizedImage, InViewportDirective, NgClass, MediaPointMapComponent],
  templateUrl: './media.component.html',
  styleUrl: './media.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaComponent {
  media = input<Media>();
  cssContainerClasses = input<string>('');
  cssClasses = input<string>('');
  videoOptions$ = input<{
    autoplay: boolean;
    controls: boolean;
    loop: boolean;
    muted: boolean;
    playsinline: boolean;
  }>({ autoplay: false, controls: false, loop: true, muted: true, playsinline: true });

  placeholderIconUrl = input<string>('https://kadodesign.nl/media/placeholder.png');

  sizes = input<string>('');
  ngSrcset = input<string>('550w, 800w, 1200w, 1600w, 1920w, 2240w, 3200w, 4100w');

  width = input<number | null>(null);
  height = input<number | null>(null);

  fill = input(false);
  priority = input(false);

  aspectRatio$ = computed(() => {
    const m = this.media();
    const w = this.width() || m?.width;
    const h = this.height() || m?.height;
    if (!w || !h) return '';
    return ` ${w} / ${h}`;
  });

  loadedImage$ = signal(false);

  mediaType$ = computed(() => {
    const m = this.media();

    if (!m) return 'none';
    if (m.fileType?.startsWith('video/')) return 'video';
    if (m.fileType?.startsWith('image/')) return 'image';
    return 'other';
  });

  readonly videlEl = viewChild<ElementRef<HTMLVideoElement>>('videoElement');

  inviewVideo(event: boolean) {
    if (event) {
      this.videlEl()?.nativeElement.play();
    } else {
      this.videlEl()?.nativeElement.pause();
    }
  }

  inviewImage(event: boolean) {
    if (!this.loadedImage$()) {
      this.loadedImage$.set(true);
    }
  }
}
